import { render, staticRenderFns } from "./LinkedInLoginBtn.vue?vue&type=template&id=84f0aaaa&"
import script from "./LinkedInLoginBtn.vue?vue&type=script&lang=js&"
export * from "./LinkedInLoginBtn.vue?vue&type=script&lang=js&"
import style0 from "./LinkedInLoginBtn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports